import { create } from 'zustand'

export type NavStore = {
  isNavCollapse: boolean
  isNavSponsor: boolean
  isNavBanner: boolean
  setIsNavCollapse: (v: boolean) => void
  setIsNavSponsor: (v: boolean) => void
  setIsNavBanner: (v: boolean) => void
}
export const useNavStore = create<NavStore>((set) => ({
  isNavCollapse: false,
  isNavSponsor: false,
  isNavBanner: false,
  setIsNavCollapse(v: boolean) {
    set({ isNavCollapse: v })
  },
  setIsNavSponsor(v: boolean) {
    set({ isNavSponsor: v })
  },
  setIsNavBanner(v: boolean) {
    set({ isNavBanner: v })
  },
}))
